import React from "react";
import { Link } from "react-router-dom";
import classes from "../Footer.module.scss";
import { Facebook, Instagram, MapPin, Mail, Phone } from "lucide-react";

const NavigationMenu = () => {
  const navMenu = [
    { id: 1, to: "/contactus", label: "Contact Us" },
    { id: 2, to: "/aboutus", label: "About Us" },
    { id: 3, to: "/gallerypage", label: "Gallery" },
    // { id: 3, to: "/", label: "Terms & Conditions" },
    // { id: 4, to: "/", label: "Privacy Policy" },
  ];

  const navQuick = [
        {
      id: 1,
      to: "https://www.google.com/maps/search/?api=1&query=Mahi+Dental+Clinic+Block+C+Sector+7+Gandhinagar",
      label: "Mahi Dental Clinic, Block C, Near Pathikashram Bus Stand, Near Gh-3 Circle, Sector-22 Gandhinagar, Gujarat, India – 382007",
      external: true,
      target: "_blank",
      rel: "noopener noreferrer",
    },
    {
      id: 2,
      to: "https://www.google.com/maps/search/?api=1&query=Mahi+Dental+Clinic+Sector+7+Gandhinagar",
      label: "View on Google Maps",
      icon: <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        viewBox="0 0 16 16"
        aria-hidden="true"
      >
        <path d="M8 0a5 5 0 0 0-5 5c0 3.866 5 11 5 11s5-7.134 5-11a5 5 0 0 0-5-5zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
      </svg>,
      external: true,
      target: "_blank",
      rel: "noopener noreferrer",
    },
    {
      id: 3,
      to: "mailto:info@mahidentalclinic.com",
      label: "info@mahidentalclinic.com",
      // icon: <Mail className="w-4 h-4" />,
      icon: <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        viewBox="0 0 16 16"
        aria-hidden="true"
      >
        <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 3.383-6.447 3.868a1 1 0 0 1-1.106 0L1 6.383V12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6.383z" />
      </svg>
      ,
      external: true,
    },
    {
      id: 4,
      to: "tel:+919978914926",
      label: "+91 9978914926",
      icon: <Phone className="w-5 h-5" />,
      external: true,
    }
  ];

  // Split the menu into two columns
  const firstColumn = navMenu.slice(0, 7); // ids 1 to 7
  const secondColumn = navQuick.slice(0, 7); // ids 7 and beyond

  return (
    <div className={`${classes.navmenuDivide}`}>

      {/* <div className={`${classes.footerDivide}`}>
        {secondColumn.map((link) => (
          <Link
            key={link.id}
            to={link.to}
            className={`${classes.navigateMenu}`}
          >
            {link.label}
          </Link>
        ))}
      </div> */}
      <div className={`${classes.footerDivide}`}>
        <h4 className={`${classes.footerHeading} !mb-2`}>Quick links</h4>
        {firstColumn.map((link) => (
          <Link
            key={link.id}
            to={link.to}
            className={`${classes.navigateMenu}`}
          >
            {link.label}
          </Link>
        ))}
      </div>
      <div className={`${classes.footerDivide}`}>
        <h4 className={`${classes.footerHeading} !mb-2`}>Contacts Us</h4>
        {secondColumn.map((link) =>
          link.external ? (
            <a
              key={link.id}
              href={link.to}
              target={link.target}
              rel={link.rel}
              className={`${classes.navigateMenu} inline-flex items-center gap-2`}
            >
              {link.icon}
              {link.label}
            </a>
          ) : (
            <Link
              key={link.id}
              to={link.to}
              className={`${classes.navigateMenu} inline-flex items-center gap-2`}
            >
              {link.icon}
              {link.label}
            </Link>
          )
        )}
      </div>
      <div className="space-y-2">
        <h4 className={`${classes.footerHeading} !mb-2`}>Follow Us</h4>
        <div className="flex gap-4">
          <a
            href="https://www.facebook.com/people/Mahi-Dental-Clinic/61576158135775/#"
            target="_blank"
            rel="noopener noreferrer"
            className={`${classes.navigateMenu}`}
          >
            <Facebook className="w-6 h-6" />
          </a>
          <a
            href="https://www.instagram.com/mahi_dental_clinic"
            target="_blank"
            rel="noopener noreferrer"
            className={`${classes.navigateMenu}`}
          >
            <Instagram className="w-6 h-6" />
          </a>
        </div>
      </div>

      {/* <div>
        <h4 className={`${classes.footerHeading} !mb-2`}>Quick links</h4>
        <div className={`${classes.footerDivide}`}>
          {firstColumn.map((link) => (
            <Link
              key={link.id}
              to={link.to}
              className={`${classes.navigateMenu}`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default NavigationMenu;
